/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import Switch from "../../switch/Switch";
import { validator } from "../../../services/form-validator/form-validator";
/***/

/* Validator */
export const LanguageFormValidator = {
  label: (e: string) => validator.isString(e),
  isoCode: (e: string) => validator.isString(e),
  default: (e: any) => e === undefined || typeof e === "boolean"
};

/***/

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function LanguageForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.Language,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
  return (
    <>
      <div className="field">
        <label htmlFor="firstName">{t("Label")}</label>

        <input type="text"
                value={data?.label || ""}
                onChange={(e) => onChange("label", e.target.value)}
                className={`${(submitted && !validator.isFieldValid(data, "label", LanguageFormValidator)) && "error"}`}
                placeholder={t("First Name")}/>
      </div>

      <div className="field">
        <label htmlFor="lastName">{t("Code ISO")}</label>
        
        <input type="text"
                value={data?.isoCode || ""}
                onChange={(e) => onChange("isoCode", e.target.value)}
                className={`${(submitted && !validator.isFieldValid(data, "isoCode", LanguageFormValidator)) && "error"}`}
                placeholder={t("Last Name")}/>
      </div>

      <div className="field">
        <label className="block text-sm font-medium text-gray-700 mb-1">{t("Set this lang as default")}</label>
        <Switch checked={data?.default ?? data?.isDefault ?? false}
            onChange={(e) => {
              onChange("default", e);
              onChange("isDefault", e);
            }}/>
      </div>

      <div className="field">
        <label className="block text-sm font-medium text-gray-700 mb-1">{t("Enable this lang")}</label>
        <Switch checked={data?.enabled ?? true}
            onChange={(e) => onChange("enabled", e)}/>
      </div>
    </>
  );
}
/***/
